import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AttachmentDTO} from '../../../../../services/api/api';
import {UtilService} from '../../../../../services/util.service';
import {AttachmentService} from '../../../../../services/attachment.service';
import {OpenModalService} from '../../../../../services/gui/modal/open-modal.service';

@Component({
  selector: '[sb-comp-attachment-list-entry]',
  templateUrl: './attachment-list-entry.component.html',
  styleUrls: ['./attachment-list-entry.component.scss'],
  standalone: false,
})
export class AttachmentListEntryComponent implements OnInit {
  @Input() attachment: AttachmentDTO;
  @Output() attachmentSelected: EventEmitter<AttachmentDTO> = new EventEmitter<AttachmentDTO>();

  @Output() dragendEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() dragstartEmitter: EventEmitter<{ event: DragEvent; item: AttachmentDTO }> = new EventEmitter<{
    event: DragEvent;
    item: AttachmentDTO;
  }>();

  hover: boolean;

  animationOptions: any = {
    autoplay: true,
    loop: true,
  };

  constructor(
    public util: UtilService,
    public attachmentService: AttachmentService,
    public openModal: OpenModalService
  ) {}

  ngOnInit(): void {}
}
